angular.module('dnecom')
    .controller('ProductProcessShippingController', ["$scope", "ZonesUtils", "wizardModal", function ProductProcessShippingController($scope, ZonesUtils, wizardModal) {
        $scope.getCostInfo = ZonesUtils.getCostInfo;
        $scope.touched = false;
        $scope.store = TemplateData.value('store');;

        $scope.$watch('product.status', function(newValue, oldValue) {
            if (newValue == "draft") {
                $scope.onFieldUpdate('shippingZones');
            }
        });

        $scope.$on('product.touchPartials', function (event, data) {
            $scope.touched = true;
        });

        $scope.$watchCollection('product.shippingZones', function() {
            $scope.onFieldUpdate('shippingZones');
        });

        $scope.shippingClasses = _.map(TemplateData.value('shippingClasses'), function (shippingClass) {
            shippingClass.zones.forEach(function (zone) {
                zone.deleted = false;
            });

            return shippingClass;
        });

        $scope.selectedClass = (function () {
            if ($scope.product.shippingZones.length == 0) {
                return null;
            }

            return _.find($scope.shippingClasses, function (shippingClass) {
                return shippingClass.id == $scope.product.shippingZones[0].shippingClass.id;
            });
        })();

        $scope.chosenZonesList = [];

        $scope.initZonesList = function () {
            if ($scope.selectedClass) {
                $scope.chosenZonesList = angular.copy($scope.selectedClass.zones);

                if ($scope.product.shippingZones) {
                    $scope.product.shippingZones.forEach(function (shippingZone) {
                        $scope.chosenZonesList.forEach(function (productZone) {
                            productZone.deleted = productZone.id == shippingZone.shippingZoneId;
                        });
                    });
                }
            }
        };

        $scope.updateZonesList = function (selectedClass) {
            $scope.product.shippingZones = [];
            $scope.selectedZone = null;
            $scope.chosenZonesList = angular.copy(selectedClass.zones);
        };

        $scope.addZone = function (zone) {
            if (!zone) {
                return;
            }

            $scope.chosenZonesList.forEach(function (chosenZone) {
                if (chosenZone.id == zone.id) {
                    chosenZone.deleted = true;
                }
            });

            $scope.selectedZone = null;

            var newZone = angular.copy(zone);

            delete newZone.id;
            newZone.shippingZoneId = zone.id;

            $scope.product.shippingZones.push(newZone);
        };

        $scope.getAdditionalPrice = function (zone) {
            if (!zone.priceRanges) {
                return 0;
            }
            return zone.priceRanges.length ? zone.priceRanges[0].cost : 0;
        };

        $scope.removeZone = function (zone) {
            $scope.product.shippingZones.forEach(function (shippingZone, index) {
                if (shippingZone.shippingZoneId == zone.shippingZoneId) {
                    $scope.product.shippingZones.splice(index, 1);
                }
            });

            $scope.chosenZonesList.forEach(function (shippingZone) {
                if (shippingZone.id == zone.shippingZoneId) {
                    shippingZone.deleted = false;
                }
            });

            zone.deleted = false;
        };

        $scope.tweakZone = function (zone) {
            var modal = wizardModal.open({
                'templateUrl': 'processTweakZoneModal.html',
                'size': 'md',
                'controller': 'ProductProcessShippingModalController',
                'resolve': {
                    'priceRanges': function () {
                        return zone.priceRanges;
                    }
                }
            });

            modal.result.then(function (priceRanges) {
                zone.priceRanges = priceRanges;
            });
        };
    }]);
